import React from 'react';
import { Editor } from 'draft-js';
import './editor.css';
import StyleControls from './StyleControls';
import { Card, Button } from 'semantic-ui-react';
import { blockTypes } from './blockTypes';
import { inlineTypes } from './inlineTypes';
import { customStyleMap } from './customStyleMap';
import PropTypes from 'prop-types';

const TextEditor = ({
  editorState,
  toggleInlineStyle,
  toggleBlockType,
  onEditorChange
}) => (
  <Card fluid>
    <Card.Content>
      <Button.Group basic size="small">
        <StyleControls
          types={inlineTypes}
          editorState={editorState}
          onToggle={toggleInlineStyle}
        />
        <StyleControls
          types={blockTypes}
          editorState={editorState}
          onToggle={toggleBlockType}
        />
      </Button.Group>
    </Card.Content>
    <Card.Content>
      <div className="editor">
        <Editor
          editorState={editorState}
          onChange={onEditorChange}
          customStyleMap={customStyleMap}
          blockStyleFn={blockStyleFn}
        />
      </div>
    </Card.Content>
  </Card>
);

function blockStyleFn(contentBlock) {
  return 'margin-bottom';
}

TextEditor.propTypes = {
  editorState: PropTypes.object.isRequired,
  toggleInlineStyle: PropTypes.func.isRequired,
  toggleBlockType: PropTypes.func.isRequired,
  onEditorChange: PropTypes.func.isRequired
};

export default TextEditor;



// WEBPACK FOOTER //
// ./src/component/TextEditor/index.js